import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListExternsComponent } from './list/list.component';
import { ShowExternComponent } from './show/show.component';

const routes: Routes = [
    {
        path: '',
        component: ListExternsComponent
    },
    {
        path: 'show/:id',
        component: ShowExternComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ExternsRoutingModule { }
